import ssCss, { SystemStyleObject } from '@styled-system/css'
import GatsbyLink from 'gatsby-link'
import React, { HTMLAttributes } from 'react'
import styled from 'styled-components'
// import { StaticImage } from "gatsby-plugin-image"
type ImgProps = HTMLAttributes<HTMLImageElement> & {
  customCss?: SystemStyleObject
}

const Img = styled('img')<ImgProps>`
  ${({ customCss }) => ssCss(customCss)}
`

export const Logo = ({
  href = '/',
  variant = 'dark',
  onClick,
}: {
  href?: string
  variant?: 'dark' | 'light'
  onClick?: () => void
}) => {
  return (
    <GatsbyLink to={href} onClick={onClick} style={{ display: 'flex' }}>
      {variant === 'dark' ? (
        <Img
          src="https://static.crypto.com/layout/navbar/company-logos/white.png"
          alt="Crypto.com white logo"
          customCss={{
            width: [141, 141, 169],
          }}
          loading="eager"
        />
      ) : (
        <Img
          src="https://static.crypto.com/layout/navbar/company-logos/blue.svg"
          alt="Crypto.com blue logo"
          customCss={{
            width: [141, 141, 169],
            height: [27, 27, 28],
          }}
          loading="eager"
        />
      )}
    </GatsbyLink>
  )
}
